import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import { LeadQueryParams } from './types';
import { parseLeadSort } from './utils/leadSort';

const getDates = (param: string, dates: string[]) => {
    return {
        [`${param}_from`]: dates[0],
        [`${param}_to`]: dates[1]
    };
};

const useQueryParams = () => {
    const [searchParams, setSearchParams] = useSearchParams();

    return useMemo(() => {
        const isMember = searchParams.get('is_member');
        const state = searchParams.get('state');

        return {
            hasFilters: [
                'search',
                'state',
                'updated',
                'created',
                'is_member',
                'state',
                'approval_status'
            ].some((key) => searchParams.has(key)),
            query: {
                limit: searchParams.get('limit') || 10,
                filter_type: searchParams.get('filter_type') || 'default',
                offset: searchParams.get('offset') || 0,
                ...(searchParams.get('updated') && {
                    ...getDates('updated', searchParams.get('updated')!.split('|'))
                }),
                ...(searchParams.get('created') && {
                    ...getDates('created', searchParams.get('created')!.split('|'))
                }),
                ...(state && {
                    state: state.split(',')
                }),
                ...(searchParams.get('search') && {
                    search: searchParams.get('search')
                }),
                ...(isMember && {
                    is_member: +isMember
                }),
                ...parseLeadSort(searchParams)
            } as LeadQueryParams,
            setSearchParams
        };
    }, [searchParams]);
};

export default useQueryParams;
